module.exports = __webpack_public_path__ + "static/media/Skeptisk.24eb13d9.m4a";